<!-- HERO SECTION STARTS HERE -->

<div class="py-hero-sec">
  <div class="hs-cnt">
    <div class="hs-cnt-right">
      <div>Summer Code</div>

      <h1 class="hs-head">Python Adventures</h1>

      <h3>Unleash Your Child’s Coding Superpower in Just 20 Days!</h3>

      <p>
        A fun, focused, and structured Python programming course designed to
        build strong foundations, spark curiosity, and unlock coding confidence
        — perfect for students stepping into the world of programming!
      </p>

      <button class="cta-1" (click)="bookSlot()">Book a Slot</button>
    </div>

    <div class="hs-cnt-left">
      <img src="assets/images/py-girl.png" />
    </div>
  </div>
</div>

<!-- HERO SECTION ENDS HERE -->


<!-- COURSE HIGHLIGHT SECTION STARTS HERE -->

<div class="ch-container">
  <h1 class="sec-head">Course Highlights</h1>

  <button class="cta-1" (click)="bookSlot()">Book a Slot</button>

  <div class="ch-cards-container">
    <div class="ch-card">
      <img src="assets/images/ch-1.jpg" alt="" />

      <h4>Pre-Lecture Materials & Summary Notes</h4>

      <p>For rapid understanding and effective revision. </p>
    </div>

    <!-- one -->
    <div class="ch-card">
      <img src="assets/images/ch-2.jpg" alt="" />

      <h4>15 Hours of Expert-Led Tuition</h4>

      <p>Engaging, hands-on sessions guided by experienced tutors.  </p>
    </div>

    <!-- two -->
    <div class="ch-card">
      <img src="assets/images/ch-3.jpg" alt="" />

      <h4>15 Assignments & 15 Practice Tests</h4>

      <p>
        Over 880 skill-building questions designed around core Python concepts. 
      </p>
    </div>

    <!-- three -->
    <div class="ch-card">
      <img src="assets/images/ch-4.jpg" alt="" />

      <h4>In-Person Mock Exams</h4>

      <p>
        Over 880 skill-building questions designed around core Python concepts.
      </p>
    </div>

    <!-- Four -->
    <div class="ch-card">
      <img src="assets/images/ch-5.jpg" alt="" />

      <h4>1 Parent-Teacher Meeting (PTM)</h4>

      <p>Tailored feedback and progress discussion. </p>
    </div>

    <!-- Five -->
    <div class="ch-card">
      <img src="assets/images/ch-6.jpg" alt="" />

      <h4>Proven Techniques & Tips</h4>

      <p>
        Learn real coding strategies, debugging skills, and logical
        problem-solving. 
      </p>
    </div>

    <!-- six -->
    <div class="ch-card">
      <img src="assets/images/ch-7.jpg" alt="" />

      <h4>Detailed Performance Report (RAR)</h4>

      <p>
        Insightful ranking, standard scores, and benchmarking against peers.  
      </p>
    </div>

    <!-- seven -->
    <div class="ch-card">
      <img src="assets/images/ch-8.jpg" alt="" />

      <h4>Personalised Review & Feedback</h4>

      <p>Close learning gaps and track growth. </p>
    </div>
  </div>

  <button class="cta-1" (click)="bookSlot()">Book a Slot</button>

</div>

<!-- COURSE HIGHLIGHT SECTION ENS HERE -->



<!-- COURSE DETAILS STARTS HERE -->

<div class="cd-sec">

<h1 class="sec-head"> Course Details</h1>

<div class="sessions-overview-row">

    <div class="session-features">
      <ul>
        <li>Logical Thinking & Problem Solving  </li>
        <li>Speed & Accuracy in Code</li>
        <li>Confident Debugging & Error Handling</li>
        <li>Time-Management during Challenges </li>
        <li>Strategic Exam Technique (where applicable) </li>
      </ul>
    </div>

    <div class="session-side-box">
      <span>Key Skill Focus</span>
    </div>
  </div>

  <div class="sessions-overview-row">

    <div class="session-features">
      <ul>
        <li>Course Duration: 20 Days</li>
        <li>Daily Hours: 1– hours per day</li>
        <li>Confident Debugging & Error Handling</li>
        <li>Delivery Mode: Online (Live & Interactive)</li>
        <li>Group Size: Small groups for personalised attention</li>
      </ul>
    </div>

    <div class="session-side-box">
      <span>Format & Delivery</span>
    </div>
  </div>

</div>

<!-- COURSE DETAILS ENDS HERE -->


<!-- DAY BY DAY BREAKDOWN -->

<div class="section-breakdown">
  <h2>Week-by-Week Breakdown</h2>

  <div class="accordion">
    <div
      class="accordion-item"
      *ngFor="let week of weeks; let i = index"
      [class.open]="openIndex === i"
    >
      <div class="accordion-header" (click)="toggleAccordion(i)">
        <span [innerHTML]="week.title"></span>
        <svg class="accordion-icon" width="32" height="32">
          <polyline points="10,14 16,20 22,14" fill="none" stroke="#222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div
        class="accordion-content"
        [style.maxHeight]="openIndex === i ? '900px' : null"
        [style.opacity]="openIndex === i ? '1' : null"
        [@accordion]="openIndex === i ? 'open' : 'closed'"
      >
        <div [innerHTML]="week.content"></div>
      </div>
    </div>
  </div>
</div>


<!-- CONTACT US -->

<div class="sessions-overview-row">

    <div class="session-features">
      <ul>
        <li>Hotline: +44(0)2039808244</li>
        <li>Email: support&#64;sehyog.co.uk</li>
        <li>WhatsApp: +44-7464772331</li>
      </ul>
    </div>

    <div class="session-side-box">
      <span>For More Info<br> Connect Us</span>
    </div>
  </div>